<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="認証ID登録エラー詳細"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <div class="detail-border">
              <label>エラー詳細</label>
              <div v-for="(e, index) in errorDetails" :key="index">
                <div class="pb-2">{{ e }}</div>
              </div>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >閉じる</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "SaIdRegisterHistoryReference",
  props: {
    /** ID登録エラー詳細 */
    errorDetails: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.detail-border {
  border: solid 3px;
  margin: 0 1em 1em 1em;
  padding: 1em;
}
</style>
